<template>
  <component :is="layout">
    <router-view/>
  </component>
</template>

<script>
import NONAV from '@/layouts/no-nav'
import DEFAULT from '@/layouts/default'
import SIDENAV from '@/layouts/side-nav'

const options = {
  NONAV,
  DEFAULT,
  SIDENAV
}

export default {
  name: 'layout-broker',
  props: {
    name: String
  },
  computed: {
    layout() {
      let component = options[this.name.toUpperCase().replace(/\W/g, '')]
      return component || NONAV
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/broker.vue